import { createPreviewMapping } from './createPreviewMapping';

export const { typeComponentMapping, typeFormatComponent } = createPreviewMapping({ includeZipPreview: true });
